export enum BoltBillData {
    'noBillHeader' = 'Introducing Bolt',
    'noBillSub' = 'Shop now & pay on 5th of next month',
    'noBillHref' = 'https://zestmoney.in/bolt/',
    'noBillCtaText' = 'Know more',
    'billCtaText' = 'View Bolts',
    'billCtaType' = 'existing',
    'noBillCtaType' = 'new',
    'nonZeroBillText' = 'Your Bolt will be generated on the 1st of every month',
    'zeroBillText' = 'Keep shopping with Bolt',
    'noBillEvent' = 'WebApp_BoltIntroduction_LearnMore',
    'billEvent' = 'WebApp_EmisBolt_ViewBills'
}
export class BoltCta {
    href: any;
    target: any;
    text: any;
    event: any;
    type: any;
}
